module.exports = __webpack_public_path__ + "img/tech 6.49b46569.png";